import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { PermissionChecker } from '../../session'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import AddNewButton from './AddNewButton'
import Container from '../../../components/structure/Container'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import Separator from '../../../components/helpers/Separator'

const MaskListPage = () => {
  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor={COLORS.white}>
      <PermissionChecker permission="listMasks">
        <Container>
          <FilterHandler tempStorageNamespace="masks" initialState={{}}>
            <PageHeader />
            <PageContent />
          </FilterHandler>
          <AddNewButton />
          <Separator weight={32} />
        </Container>
      </PermissionChecker>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default MaskListPage
